/**
 * ExternalPaymentSystem entity class
 */

/**
 * ExternalPaymentSystemFactory
 * returns ExternalPaymentSystem entity class
 *
 * @class ExternalPaymentSystemFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.Location} class
 *
 * @ngdoc factory
 * @name mwApp.factory:ExternalPaymentSystemFactory
 */
/* @ngInject */
export default function ExternalPaymentSystemFactory ($http, alertLiteSvc, Entity, Type) {
  /* === ExternalPaymentSystem class === */

  /**
   * Location model
   *
   * @class ExternalPaymentSystem
   * @classdesc ExternalPaymentSystem model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @param {Object} [Object] - initial object, containing Location entity fields
   * @return {models.ExternalPaymentSystem} ExternalPaymentSystem entity
   */
  function ExternalPaymentSystem () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  ExternalPaymentSystem.prototype = Object.create(Entity.prototype)
  ExternalPaymentSystem.prototype.constructor = ExternalPaymentSystem

  /* === ExternalPaymentSystem instance methods & fields === */

  Object.assign(ExternalPaymentSystem.prototype, {

    /**
     * instance fields
     *
     * @memberof models.ExternalPaymentSystem#
     * @type {Object}
     */
    _fields: {
      id: Number,
      externalPaymentSystemType: Type(String('')),
      enabled: Boolean,
      transactionIdRequired: Boolean
    }
  })

  /* === Location static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(ExternalPaymentSystem, Entity)
  ExternalPaymentSystem._name = 'ExternalPaymentSystem'
  ExternalPaymentSystem._publicName = 'ExternalPaymentSystem'
  ExternalPaymentSystem.init()

  return ExternalPaymentSystem
}
